import type { IServiceMethod } from '@/shared/api';
import { appApi } from '@/shared/api';

const sendCampaignJoinPopup: IServiceMethod<void, void[]> = () => appApi.post('postback/on-popup-join', {}, true);

sendCampaignJoinPopup.queryKey = 'sendCampaignJoinPopup';

const sendCampaignClosePopup: IServiceMethod<void, void[]> = () => appApi.post('postback/on-popup-close', {}, true);

sendCampaignClosePopup.queryKey = 'sendCampaignClosePopup';
export const CampaignService = { sendCampaignClosePopup, sendCampaignJoinPopup };
